import React, { Component } from 'react'

class SharePage extends Component {
  render () {
    return (
      <div>
        <h1>Share</h1>
      </div>
    )
  }
}

export default SharePage



// WEBPACK FOOTER //
// ./src/components/sharepage.js